<div class="px-4 py-3 flex flex-column h-full">
  <p-toast position="top-right" key="toastError"></p-toast>
  <p-toast position="top-right" key="toastSuccess"></p-toast>

  <p-card styleClass="mb-3 flex-shrink-0">
    <p-fieldset legend="Filtros" [toggleable]="true">
      <div class="grid mt-2">

        <div class="col-12 md:col-3 mt-3">
          <span class="p-float-label"
              pTooltip="Reproduzir ou visualizar outros vídeos ocasionará o descarte da contagem e do vídeo atualmente reproduzido."
                tooltipPosition="top"
                [tooltipDisabled]="!areFiltersLocked">
            <p-dropdown
              [(ngModel)]="videoFilter.device"
              (ngModelChange)="onDeviceChange()"
              [options]="devices"
              optionLabel="deviceName"
              optionValue="deviceId"
              [style]="stylePattern"
              inputId="filterDevice"
              [filter]="true"
              [showClear]="true"
              [ngClass]="activeTab?.id === 'video' && !videoFilter.device ? 'field-invalid' : ''"
              placeholder="Selecionar"
            ></p-dropdown>
            <label htmlFor="filterDevice">
              Equipamento
              <span *ngIf="activeTab?.id === 'video' && !videoFilter.device" class="required-mark">*</span>
            </label>
          </span>
        </div>

        <div class="col-12 md:col-3 mt-3">
          <span class="p-float-label"
                [pTooltip]="areFiltersLocked
                  ? 'Reproduzir ou visualizar outros vídeos ocasionará o descarte da contagem e do vídeo atualmente reproduzido.'
                  : 'Selecione um equipamento antes de escolher a pista.'"
                tooltipPosition="top"
                [tooltipDisabled]="areFiltersLocked ? false : !!videoFilter.device">
            <p-dropdown
              [(ngModel)]="videoFilter.lane"
              (ngModelChange)="captureUploadedVideoSummaryIfReady()"
              [dropdownIcon]="loadingLane ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'"
              [filter]="true"
              [showClear]="true"
              [style]="stylePattern"
              [options]="lanes"
              optionLabel="label"
              optionValue="id"
              inputId="filterLane"
              [disabled]="!videoFilter.device"
              [ngClass]="activeTab?.id === 'video' && !videoFilter.lane ? 'field-invalid' : ''"
              placeholder="Selecionar"
            ></p-dropdown>
            <label htmlFor="filterLane">
              Pista
              <span *ngIf="activeTab?.id === 'video' && !videoFilter.lane" class="required-mark">*</span>
            </label>
          </span>
        </div>

        <div class="col-12 md:col-3 mt-3">
          <span class="p-float-label"
                pTooltip="Reproduzir ou visualizar outros vídeos ocasionará o descarte da contagem e do vídeo atualmente reproduzido."
                tooltipPosition="top"
                [tooltipDisabled]="!areFiltersLocked">
            <p-calendar
              [style]="stylePattern"
              [readonlyInput]="true"
              [showButtonBar]="true"
              [maxDate]="maxDate"
              [minDate]="$any(activeTab?.id === 'video' ? minDate : null)"
              inputId="filterRange"
              [class]="activeTab?.id === 'video' && !videoFilter.date ? 'field-invalid' : ''"
              [(ngModel)]="videoFilter.date"
              (ngModelChange)="captureUploadedVideoSummaryIfReady()"
              (onSelect)="onReportDateSelect()"
              (onClear)="onDateClear()"
            ></p-calendar>
            <label htmlFor="filterRange">
              Data
              <span *ngIf="activeTab?.id === 'video' && !videoFilter.date" class="required-mark">*</span>
            </label>
          </span>
        </div>

        <div *ngIf="activeTab?.id === 'video'" class="col-12 md:col-3 mt-3">
          <span class="p-float-label" 
                pTooltip="Reproduzir ou visualizar outros vídeos ocasionará o descarte da contagem e do vídeo atualmente reproduzido."
                tooltipPosition="top"
                [tooltipDisabled]="!areFiltersLocked">
            <p-calendar
              [style]="stylePattern"
              [(ngModel)]="videoFilter.startHour"
              [timeOnly]="true"
              (onSelect)="onStartHourChange($event)"
              (onClear)="onStartHourClear()"
              [class]="!videoFilter.startHour ? 'field-invalid' : ''"
              inputId="filterStartHour">
            </p-calendar>
            <label htmlFor="filterStartHour">
              Hora ocorrência
              <span *ngIf="!videoFilter.startHour" class="required-mark">*</span>
            </label>
          </span>
        </div>

        <div *ngIf="activeTab?.id === 'relatorios'" class="col-12 md:col-3 mt-3">
          <span class="p-float-label"
                pTooltip="Reproduzir ou visualizar outros vídeos ocasionará o descarte da contagem e do vídeo atualmente reproduzido."
                tooltipPosition="top"
                [tooltipDisabled]="!areFiltersLocked">
            <p-calendar
              [style]="stylePattern"
              [readonlyInput]="true"
              [maxDate]="getMaxTime('start')"
              [timeOnly]="true"
              [showTime]="true"
              hourFormat="24"
              inputId="filterReportStartHour"
              placeholder="hh:mm"
              [(ngModel)]="videoFilter.startHour"
              (ngModelChange)="onStartHourChange($event)"
              [ngClass]="getLimitClass('start')"
            ></p-calendar>
            <label htmlFor="filterReportStartHour">Hora Início</label>
          </span>
        </div>

        <div *ngIf="activeTab?.id === 'relatorios'" class="col-12 md:col-3 mt-3">
          <span class="p-float-label"
                pTooltip="Reproduzir ou visualizar outros vídeos ocasionará o descarte da contagem e do vídeo atualmente reproduzido."
                tooltipPosition="top"
                [tooltipDisabled]="!areFiltersLocked">
            <p-calendar
              [style]="stylePattern"
              [readonlyInput]="true"
              [maxDate]="getMaxTime('end')"
              [timeOnly]="true"
              [showTime]="true"
              hourFormat="24"
              inputId="filterReportEndHour"
              placeholder="hh:mm"
              [(ngModel)]="videoFilter.endHour"
              (ngModelChange)="onEndHourChange($event)"
              [ngClass]="getLimitClass('end')"
            ></p-calendar>
            <label htmlFor="filterReportEndHour">Hora Fim</label>
          </span>
        </div>

<div class="col-12 mt-3 grid align-items-end">
  <div
    *ngIf="activeTab?.id === 'video'"
    class="col-12 md:col-3"
    pTooltip="O vídeo inclui uma margem de 5 segundos em cada extremidade para compensar possíveis diferenças de sincronização."
    [tooltipDisabled]="areFiltersLocked"
    tooltipPosition="top"
    >
      <span class="p-float-label"
            pTooltip="Reproduzir ou visualizar outros vídeos ocasionará o descarte da contagem e do vídeo atualmente reproduzido."
            tooltipPosition="top"
            [tooltipDisabled]="!areFiltersLocked">
            
              <span class="p-float-label"
                    pTooltip="Reproduzir ou visualizar outros vídeos ocasionará o descarte da contagem e do vídeo atualmente reproduzido."
                    tooltipPosition="top"
                    [tooltipDisabled]="!areFiltersLocked">
              <input
                *ngIf="uploadedMetadataAutoFilled; else durationDropdown"
                pInputText
                readonly
                [value]="formatDuration(videoFilter.duration)"
                [style]="stylePattern"
                inputId="filterDuration"
              />
              <ng-template #durationDropdown>
                <p-dropdown
                  [(ngModel)]="videoFilter.duration"
                  (ngModelChange)="captureUploadedVideoSummaryIfReady()"
                  [options]="durationOptions"
                  optionLabel="label"
                  optionValue="value"
                  [style]="stylePattern"
                  [ngClass]="!videoFilter.duration ? 'field-invalid' : ''"
                  inputId="filterDuration"
                ></p-dropdown>
              </ng-template>
              <label for="filterDuration">
                Duração
                <span *ngIf="!videoFilter.duration" class="required-mark">*</span>
              </label>
            </span>
          </span>
        </div>


  <div *ngIf="activeTab?.id === 'video'" class="col-12 md:col-9 flex align-items-end justify-content-end gap-2">
    <i class="pi pi-info-circle download-info-icon"
      tooltipPosition="right"
      [pTooltip]="downloadingVideo ? 'Use o botão vermelho para cancelar o download.' : 'O nome do arquivo baixado é essencial para o upload. A renomeação do mesmo NÃO é recomendada.'"
    ></i>
    <span
      pTooltip="Preencha os filtros para habilitar o botão."
      [tooltipDisabled]="canPlayVideo() && !loading">
      <p-button
        [style]="{ height: '40px' }"
        tooltipPosition="top"
        [style.--download-progress]="downloadProgress + '%'"
        [styleClass]="downloadingVideo ? 'download-video-button is-loading' : 'download-video-button'"
        [disabled]="!canPlayVideo() || loading || downloadingVideo"
        [icon]="downloadingVideo ? 'pi pi-spinner pi-spin' : 'pi pi-download'"
        iconPos="left"
        [label]="downloadingVideo ? (downloadPhase === 'TRANSCODING' ? 'Processando vídeo...' : downloadPhase === 'TRANSFERRING_RESULT' ? 'Preparando arquivo...' : 'Baixando...') : 'Baixar'"
        size="small"
        severity="help"
        (onClick)="!downloadingVideo && downloadVideo()"
      ></p-button>
    </span>
    <p-button
      *ngIf="downloadingVideo"
      styleClass="download-cancel-button"
      icon="pi pi-times"
      severity="danger"
      pTooltip="Cancelar download"
      tooltipPosition="top"
      ariaLabel="Cancelar download"
      (onClick)="cancelDownload()"
    ></p-button>
    <p-button
      [style]="{ height: '40px' }"
      label="Upload MP4"
      size="small"
      icon="pi pi-upload"
      (onClick)="uploadInput.click()"
    ></p-button>
    <span
      pTooltip="Preencha os filtros para habilitar o botão."
      [tooltipDisabled]="canPlayVideo() && !loading">
      <p-button
        [style]="{ height: '40px' }"
        styleClass="play-video-button"
        [disabled]="!canPlayVideo() || loading || isUploadedVideo"
        label="Reproduzir"
        size="small"
        icon="pi pi-play"
        [loading]="loading"
        (onClick)="getOccurrence(false, videoFilter)"
      ></p-button>
    </span>
    <input
      #uploadInput
      type="file"
      accept="video/mp4,.mp4"
      style="display: none"
      (change)="onVideoFileSelected($event)"
    />
    <p-button
      [style]="{ height: '40px' }"
      label="Limpar"
      size="small"
      icon="pi pi-times"
      severity="secondary"
      [outlined]="true"
      (onClick)="clearFilter()"
    ></p-button>
  </div>

  <div *ngIf="activeTab?.id === 'relatorios'" class="col-12 flex justify-content-end gap-2">
    <p-button
      [style]="{ height: '40px' }"
      [disabled]="!canGenerateReport() || loadingReports"
      label="Gerar relatório"
      size="small"
      icon="pi pi-search"
      [loading]="loadingReports"
      (onClick)="generateReport()"
    ></p-button>
    <p-button
      [style]="{ height: '40px' }"
      label="Limpar"
      size="small"
      icon="pi pi-times"
      severity="secondary"
      [outlined]="true"
      (onClick)="clearFilter()"
    ></p-button>
  </div>

        </div>
      </div>
    </p-fieldset>
  </p-card>

  <div>

    <div class="relative mb-3">
      <p-tabMenu [model]="tabItems" [activeItem]="activeTab" (activeItemChange)="onTabChange($event)"></p-tabMenu>
      <span *ngIf="activeTab?.id === 'video' && appliedVideoFilterSummary" class="text-700 font-bold text-right"
            style="position: absolute; top: 50%; right: 2%; transform: translateY(-50%);">
        Vídeo: {{ appliedVideoFilterSummary}}
      </span>
    </div>

    <div [hidden]="activeTab?.id !== 'video'" class="grid flex-1 m-0 min-h-0">
      <div class="col-12 lg:col-9 p-2 flex flex-column min-h-0">

        <div *ngIf="!videoLoaded"
          class="flex flex-column align-items-center justify-content-center gap-3 border-round flex-1"
          style="border: 2px dashed #cbd5e1; background: #f8fafc;">
        <div class="flex align-items-center justify-content-center border-circle bg-primary-50"
            style="width: 64px; height: 64px;">
          <i [class]="loading ? 'pi pi-spin pi-spinner text-primary text-4xl' : 'pi pi-video text-primary text-4xl'"></i>
        </div>
        <div class="text-center">
          <p class="m-0 font-semibold text-800">{{ loading ? 'Carregando vídeo...' : 'Nenhum vídeo carregado' }}</p>
          <p *ngIf="!loading" class="m-0 mt-1 text-sm text-400">
            Utilize os filtros acima e clique em <strong class="text-primary">Reproduzir</strong> ou <strong class="text-primary">Upload</strong>
          </p>
        </div>
      </div>

      <div *ngIf="videoLoaded"
          #videoContainer
          class="relative overflow-hidden border-round video-feed">

        <div class="video-scanlines absolute" style="inset: 0; pointer-events: none; z-index: 2;"></div>

        <div class="absolute flex flex-column align-items-center gap-2 p-3 border-round video-overlay"
            style="top: 16px; right: 16px; z-index: 3;
                    background: rgba(0,0,0,0.6); backdrop-filter: blur(4px); min-width: 140px;">

          <div class="flex align-items-center justify-content-between w-full">
            <span class="text-xs font-bold uppercase" style="color: rgba(255,255,255,0.5); letter-spacing: 0.06em;">
              Contador de Passagens
            </span>
          </div>

          <span class="font-bold text-4xl counter-overlay-value" [ngClass]="countColorClass" [class.counter-pulse]="counterPulse">
            {{ formattedCount }}
          </span>

          <span *ngIf="videoTimestamp" class="text-xs font-mono" style="color: rgba(255,255,255,0.45); letter-spacing: 0.04em;">
            {{ videoTimestamp }}
          </span>
          <div class="flex gap-2 w-full">
            <button
              class="p-button flex-1 flex align-items-center justify-content-center border-round py-2"
              style="background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); color: white; cursor: pointer;"
              [disabled]="!videoLoaded || passageCount === 0"
              [class.p-disabled]="!videoLoaded || passageCount === 0"
              (click)="decrementCount()">
              <i class="pi pi-minus text-xs"></i>
            </button>
            <button
              class="p-button flex-1 flex align-items-center justify-content-center border-round py-2"
              style="background: rgba(68,114,196,0.8); border: none; color: white; cursor: pointer;"
              [disabled]="!videoLoaded"
              [class.p-disabled]="!videoLoaded"
              (click)="incrementCount()">
              <i class="pi pi-plus text-xs"></i>
            </button>
          </div>

          <div class="w-full flex align-items-center justify-content-between pt-2 mt-1"
            style="border-top: 1px solid rgba(255,255,255,0.15);">
            <span class="text-xs font-bold uppercase" style="color: rgba(255,255,255,0.5); letter-spacing: 0.06em;">
              Velocidade
            </span>
          </div>

          <div class="flex align-items-center justify-content-center gap-2 w-full">
              <p-button
                icon="pi pi-minus"
                styleClass="speed-btn"
                [text]="true"
                [disabled]="currentSpeedIndex === 0"
                (onClick)="adjustPlaybackRate(-1)"
              ></p-button>
            <span class="speed-value">{{ videoSpeed }}x</span>
              <p-button
                icon="pi pi-plus"
                styleClass="speed-btn"
                [text]="true"
                [disabled]="currentSpeedIndex === speedOptions.length - 1"
                (onClick)="adjustPlaybackRate(1)"
              ></p-button>
          </div>

          <button class="w-full flex align-items-center justify-content-center gap-2 border-round py-2 mt-1"
                  style="background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.15);
                        color: rgba(255,255,255,0.7); cursor: pointer; font-size: 11px;"
                  (click)="toggleFullscreen()">
            <i [class]="isFullscreen ? 'pi pi-window-minimize text-xs' : 'pi pi-window-maximize text-xs'"></i>
            <span>{{ isFullscreen ? 'Minimizar' : 'Tela cheia' }}</span>
          </button>
        </div>

        <video
          #videoPlayer
          style="width: 100%; height: 100%; object-fit: contain; z-index: 1; display: block;"
          muted
          controls
          controlsList="nofullscreen"
          playsinline
          (ended)="onVideoEnded()"
          (dblclick)="onVideoDoubleClick($event)"
        ></video>
      </div>
    </div>

    <div class="col-12 lg:col-3 p-2 flex flex-column min-h-0">

      <p-card styleClass="flex-shrink-0">
        <ng-template pTemplate="header">
          <div class="flex align-items-center justify-content-between px-3 pt-3">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-chart-line" style="color: #4472C4;"></i>
              <span class="font-semibold text-sm">Contador de Passagens</span>
            </div>
          </div>
        </ng-template>

        <div class="flex flex-column align-items-center py-3 gap-1">
          <span
            class="font-bold counter-number counter-sidebar-value"
            [ngClass]="countColorClass"
            [class.counter-pulse]="counterPulse"
          >{{ formattedCount }}</span>
          <span class="text-xs text-400 text-gray-900">Passagens registradas</span>
        </div>

        <div class="flex gap-2 justify-content-center">
            <p-button
              icon="pi pi-minus"
              label="Diminuir"
              [outlined]="true"
              severity="secondary"
              styleClass="w-full justify-content-center"
              [disabled]="!videoLoaded || passageCount === 0"
              (onClick)="decrementCount()"
            ></p-button>
          <p-button
            icon="pi pi-plus"
            label="Aumentar"
            styleClass="flex-1 counter-action"
            [disabled]="!videoLoaded"
            (onClick)="incrementCount()"
          ></p-button>
        </div>

        <ng-template pTemplate="footer">
          <p-divider></p-divider>
          <div class="flex justify-content-center gap-2">
            <p-button
              label="Zerar"
              icon="pi pi-refresh"
              severity="danger"
              [text]="true"
              size="small"
              [disabled]="!videoLoaded || !isPlaying || passageCount === 0"
              (onClick)="resetCount()"
            ></p-button>
            <span
              [pTooltip]="!videoLoaded
                ? 'É necessário reproduzir ou carregar um vídeo antes de salvar.'
                : (isUploadedVideo && !uploadedMetadataAutoFilled
                ? 'Não foi possível reconhecer os dados do vídeo pelo nome do arquivo. Preencha equipamento, pista, data, hora e duração manualmente para habilitar o botão.'
                : 'Preencha os filtros para habilitar o botão.')"
              tooltipPosition="top"
              [tooltipDisabled]="canSaveCount()"
            >
              <p-button
                label="Salvar"
                icon="pi pi-save"
                severity="success"
                [text]="true"
                size="small"
                [disabled]="!canSaveCount()"
                [loading]="savingCount"
                (onClick)="saveCount()"
              ></p-button>
            </span>
          </div>
        </ng-template>
      </p-card>

      <p-card *ngIf="counterHistory.length > 0"
              styleClass="flex-1 flex flex-column min-h-0 mt-3">
        <ng-template pTemplate="header">
          <div class="px-3 pt-3 pb-2 border-bottom-1 surface-border">
            <span class="text-xs font-bold text-500 uppercase"
                  style="letter-spacing: 0.03em;">Histórico Recente</span>
          </div>
        </ng-template>

        <div class="flex-1 overflow-y-auto px-3 max-h-18rem">
          <div class="flex align-items-center justify-content-between py-2 border-bottom-1 surface-border text-xs font-bold text-500 uppercase" style="letter-spacing: 0.03em;">
            <span class="flex-1">Tempo</span>
            <span class="flex-1 text-center">Ação</span>
            <span class="flex-1 text-center">Contagem</span>
            <span class="flex-1 text-right">Replay</span>
          </div>

          <div
            *ngFor="let item of counterHistory"
            class="flex align-items-center justify-content-between py-2 border-bottom-1 surface-border text-xs"
          >
            <span class="flex-1 text-700 font-mono">{{ item.time }}</span>
            <span class="flex-1 text-center font-medium text-700">{{ item.action }}</span>
            <span class="flex-1 text-center font-medium font-bold text-lg text-blue-900">{{ item.count }}</span>
            <span class="flex-1 text-right">
                <p-button
                  label="Replay"
                  icon="pi pi-replay"
                  styleClass="replay-btn"
                  [text]="true"
                  [disabled]="!videoLoaded || item.videoTime === null || item.videoTime === undefined"
                  pTooltip="Voltar vídeo para este momento"
                  (onClick)="replayAt(item)"
                ></p-button>
            </span>
          </div>
        </div>
      </p-card>

      <div class="surface-50 border-1 surface-border border-round p-3 flex-shrink-0 mt-3">
        <span
          class="block text-xs font-bold text-400 mb-2 uppercase"
          style="letter-spacing: 0.06em;"
        >
          Atalhos
        </span>

        <div class="flex flex-column gap-2">
          <span class="flex align-items-center gap-2 text-xs text-600">
            <kbd class="shortcut-key">↑</kbd>
            <span>Aumentar contagem</span>
          </span>

          <span class="flex align-items-center gap-2 text-xs text-600">
            <kbd class="shortcut-key">↓</kbd>
            <span>Diminuir contagem</span>
          </span>

          <span class="flex align-items-center gap-2 text-xs text-600">
            <kbd class="shortcut-key">R</kbd>
            <span>Zerar contagem</span>
          </span>

          <span class="flex align-items-center gap-2 text-xs text-600">
            <kbd class="shortcut-key">+</kbd>
            <span>Aumentar vel. video</span>
          </span>

          <span class="flex align-items-center gap-2 text-xs text-600">
            <kbd class="shortcut-key">-</kbd>
            <span>Diminuir vel. video</span>
          </span>
        </div>
      </div>

    </div>
  </div>

  <div *ngIf="activeTab?.id === 'relatorios'" class="flex-1 m-0 min-h-0">
    <p-card styleClass="h-full">

      <ng-template pTemplate="header">
        <div class="flex align-items-center justify-content-between px-3 pt-3">
          <div class="flex align-items-center gap-2">
            <i class="pi pi-file-edit" style="color: #4472C4;"></i>
            <span class="font-semibold">Relatórios de Contagem</span>
          </div>
          <span class="text-xs text-700">Filtros aplicados: {{ getFilterSummary() }}</span>
        </div>
      </ng-template>

      <p-table
        [value]="generatedReportRows"
        [columns]="reportColumns"
        [paginator]="true"
        [rows]="20"
        [rowsPerPageOptions]="[10, 20, 50]"
        [showCurrentPageReport]="true"
        [loading]="loadingReports"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
        styleClass="p-datatable-sm p-datatable-striped">

        <ng-template pTemplate="caption">
          <div class="flex justify-content-between gap-1 ml-2">
            <div class="ml-2">
              <p-button
                icon="pi pi-trash"
                styleClass="export-report-button delete-report-button"
                size="small"
                [disabled]="!selectedReportRows.length || loadingReports"
                (onClick)="deleteReportCount()"
              ></p-button>
            </div>
            <div class="flex justify-content-end gap-2">
              <p-button
                label="Exportar CSV"
                icon="pi pi-file-export"
                styleClass="export-report-button"
                size="small"
                [disabled]="!generatedReportRows.length"
                (onClick)="exportReportCsv()"
              ></p-button>
              <p-button
                label="Exportar PDF"
                icon="pi pi-file-pdf"
                styleClass="export-report-button"
                size="small"
                [disabled]="!generatedReportRows.length"
                (onClick)="exportReportPdf()"
              ></p-button>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header" let-columns>
          <tr>
            <th class="text-center">
              <p-checkbox
                inputId="select-all-report-counts"
                [ngModel]="areAllReportRowsSelected"
                (ngModelChange)="toggleAllReportRows($event)"
                [binary]="true"
              ></p-checkbox>
            </th>
            <th
              *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              [ngClass]="getReportColumnClass(col.field)">
              {{ col.header }}<p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row let-columns="columns">
          <tr>
            <td class="text-center">
              <p-checkbox
                [inputId]="'report-count-' + row.id"
                [(ngModel)]="row.selected"
                [binary]="true"
              ></p-checkbox>
            </td>
            <td *ngFor="let col of columns" [ngClass]="getReportColumnClass(col.field)">
              {{ row[col.field] }}
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="reportColumns.length + 1" class="text-center py-4">
              <div class="flex flex-column align-items-center gap-2">
                <i class="pi pi-inbox text-4xl text-300"></i>
                <span class="text-500">
                  {{ reportGenerated ? 'Nenhum dado encontrado para os filtros informados' : 'Informe os filtros e gere o relatório' }}
                </span>
              </div>
            </td>
          </tr>
        </ng-template>

      </p-table>
    </p-card>
  </div>
  </div>
</div>
